// The wording under a pallet card whose PPECB consignment is undecided (UF-20).
// Pure, so the status x role decision is testable without rendering a card.

/** Consignment states where PPECB has not accepted the message: a validation
 *  failure or a draft. Nothing is waiting on PPECB there. */
const NOT_ACCEPTED = new Set(['FAILED', 'DRAFT'])
/** States where the message is with PPECB and a result is on its way. */
const AWAITING = new Set(['SUBMITTING', 'SUBMITTED', 'VALIDATED'])

const DEFAULT_NOTE = 'On a PPECB consignment with no result yet. To change this pallet, recall the consignment first.'

const HEAD = 'PPECB has not accepted this consignment yet.'

/** Not accepted: the wording follows who can amend (needs the message on
 *  Titan) and who can recall. Inspectors and dispatchers amend, not recall. */
function notAcceptedNote(fixable: boolean, canRecall: boolean): string {
  if (fixable && canRecall) return `${HEAD} On With PPECB, fix the errors and tap Amend & revalidate, or tap Recall (mistake) and send it again.`
  if (fixable) return `${HEAD} On With PPECB, fix the errors and tap Amend & revalidate. To send it again, ask a manager to recall it.`
  if (canRecall) return `${HEAD} On With PPECB, fix the errors, tap Recall (mistake), and send it again.`
  return `${HEAD} Ask a manager to fix it and send it again.`
}

function awaitingNote(canRecall: boolean): string {
  return canRecall
    ? 'With PPECB, waiting for the result. To change this pallet, tap Recall (mistake) on the consignment first.'
    : 'With PPECB, waiting for the result. To change this pallet, ask a manager to recall it first.'
}

export interface PpecbNoteWho { onTitan?: boolean; canAmend?: boolean; canRecall?: boolean }

/** The sentence for a pallet on an undecided PPECB consignment. "Waiting" only
 *  while PPECB really has it; Amend / Recall named only for who can use them. */
export function ppecbNoteText(status: string | undefined, who: PpecbNoteWho = {}): string {
  const st = status ?? ''
  if (NOT_ACCEPTED.has(st)) return notAcceptedNote(!!who.canAmend && !!who.onTitan, !!who.canRecall)
  if (AWAITING.has(st)) return awaitingNote(!!who.canRecall)
  return DEFAULT_NOTE
}
